<template>
  <div class="checkPage">
    <div id="checkChart"></div>
  </div>
</template>
<script>
export default {
  name: "checkChart",
  props: ["checkData"],

  data() {
    return {
      sensorType: "",
      machineAddress: "",
      sensorTypeName: "",
      sensorUnitType: "",
      xData: [],
      yData: []
    };
  },
  mounted() {
    this.$nextTick(() => {
      console.log("获取的source" + this.checkData);
      this.sensorType = this.checkData.sensorType;
      this.machineAddress = this.checkData.machineAddress;
      this.sensorTypeName = this.checkData.sensorTypeName;
      this.sensorUnitType = this.checkData.sensorUnitType;
      this.getSource();
    });
  },
  methods: {
    getSource() {
      //获取折线图数据
      let _this = this;
      _this.$api.Page.chartData({
        machineAddress: _this.machineAddress,
        sensorType: _this.sensorType
      })
        .then(res => {
          if (res.code == "1") {
            console.log(res.data);
            let xSource = [];
            xSource = res.data.xaxises;
            xSource.forEach(SelectTime);
            function SelectTime(item, index) {
              _this.xData.push(item.substr(10, 12));
            }
            _this.yData = res.data.yaxises;
            this.checkLine();
          } else {
            console.log(res.msg);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    checkLine() {
      //构建折线图
      let _this = this;
      // 基于准备好的dom，初始化echarts实例
      let checkChart = _this.$echarts.init(
        document.getElementById("checkChart")
      );
      // 绘制图表
      //   _this.checkChart.clear();
      checkChart.setOption(
        {
          tooltip: {
            trigger: "axis",
            formatter: function(params) {
              var color = params.color; //图例颜色
              var htmlStr = "<div>";
              htmlStr += "时间：" + params[0].axisValue + ":00 <br/>"; //x轴的名称
              //为了保证和原来的效果一样，这里自己实现了一个点的效果
              htmlStr += "<span ></span>";
              //添加一个汉字，这里你可以格式你的数字或者自定义文本内容
              htmlStr +=
                params[0].seriesName +
                "：" +
                Number(params[0].value).toFixed(1) +
                _this.sensorUnitType;
              htmlStr += "</div>";
              return htmlStr;
            },
            extraCssText: "transform: rotate(90deg)"
          },
          xAxis: {
            type: "value", //数据
            position: "top", //x 轴的位置【top bottom】
            nameRotate: -90, //坐标轴名字旋转，角度值。
            axisLabel: {
              //坐标轴刻度标签的相关设置。
              rotate: 90 //刻度标签旋转的角度，
            },
            // min: 0,
            scale: true, //是否是脱离 0 值比例
            name:
              _this.sensorTypeName + " 单位（" + _this.sensorUnitType + "）",
            axisLine: {
              //坐标 轴线
              lineStyle: {
                color: "#333",
                width: 2,
                shadowColor: "#32b17a", //阴影颜色
                shadowOffsetX: 0, //阴影水平方向上的偏移距离。
                shadowOffsetY: 0, //阴影垂直方向上的偏移距离
                shadowBlur: 10, //图形阴影的模糊大小。
                opacity: 0.6
              },
               onZero: false
            },
            splitLine: {
              show: false
            },
            splitArea: {
              //坐标轴在 grid 区域中的分隔区域，默认不显示。
              interval: "auto",
              show: false, //是否显示分隔区域
              areaStyle: {
                color: ["rgba(250,250,250,0.3)", "rgba(200,200,200,0.3)"], //分隔区域颜色。分隔区域会按数组中颜色的顺序依次循环设置颜色。默认是一个深浅的间隔色。
                shadowColor: "red", //阴影颜色
                shadowOffsetX: 0, //阴影水平方向上的偏移距离。
                shadowOffsetY: 0, //阴影垂直方向上的偏移距离
                shadowBlur: 10, //图形阴影的模糊大小。
                opacity: 1 //图形透明度。支持从 0 到 1 的数字，为 0 时不绘制该图形
              }
            }
          },
          yAxis: {
            type: "category",
            name: "(时间)",
            inverse: "true", //是否是反向坐标轴。
            nameRotate: -90, //坐标轴名字旋转，角度值。
            axisLabel: {
              interval: 2,
              rotate: -110,
              formatter: function(value, index) {
                //使用函数模板，函数参数分别为刻度数值（类目），刻度的索引
                return value + ":00";
              }
            },
            // min: 0,
             scale: true, //是否是脱离 0 值比例
            data: _this.xData,
            axisLine: {
              //坐标 轴线
              lineStyle: {
                color: "#333",
                width: 2,
                shadowColor: "#32b17a", //阴影颜色
                shadowOffsetX: 0, //阴影水平方向上的偏移距离。
                shadowOffsetY: 0, //阴影垂直方向上的偏移距离
                shadowBlur: 10, //图形阴影的模糊大小。
                opacity: 0.6
              }
            }
          },
          grid: {
            top: 45,
            left: 10,
            right: 40,
            bottom: 55,
            containLabel: true
          },
          series: [
            {
              name: _this.sensorTypeName,
              type: "line",
              data: _this.yData,
              smooth: true,
              // symbol: "circle",
              showSymbol: false,
              symbolSize: 5,
              sampling: "average",
              itemStyle: {
                normal: {
                  color: ["#32b17a"],
                  lineStyle: {
                    width: 3
                  }
                }
              },
              areaStyle: {
                color: new _this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "rgba(82,206,86,0.8)"
                  },
                  {
                    offset: 0.4,
                    color: "rgba(82,206,86,0.3)"
                  },
                  {
                    offset: 1,
                    color: "rgba(82,206,86,0.00)"
                  }
                ])
              }
            }
          ]
        },
        true
      );
    }
  },
  watch: {
    checkData: function(checkData) {
      console.log(JSON.stringify(checkData));
      this.sensorType = checkData.sensorType;
      this.machineAddress = checkData.machineAddress;
      this.sensorTypeName = checkData.sensorTypeName;
      this.sensorUnitType = checkData.sensorUnitType;
      this.xData = [];
      this.yData = [];
      this.getSource();
    }
  }
};
</script>
<style lang="less">
.checkPage {
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: relative;

  #checkChart {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background-color: #fff;
  }
}
</style>    
